import Styled from "@emotion/styled";
import { Grid } from "@mui/material";
import { _url } from "../../../config/utils";

export const FinaliseContainer = Styled(Grid)`
    background-image: url(${_url("assets/redesign/icons/finalise_cloud.png")});
    background-size: cover;
    background-repeat: no-repeat;
`;
